// src/lib/auth.js
import { jwtDecode } from 'jwt-decode'; // <-- named export στη v4

const STORAGE_KEY = 'authTokens';

export function setTokens(tokens) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
}

export function getTokens() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setAccessToken(newAccess) {
  const t = getTokens() || {};
  t.access = newAccess;
  setTokens(t);
}

export function setRefreshToken(newRefresh) {
  const t = getTokens() || {};
  t.refresh = newRefresh;
  setTokens(t);
}

export function clearTokens() {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem('user');
}

export function getAccessToken() {
  const t = getTokens();
  return t?.access || null;
}

export function getRefreshToken() {
  const t = getTokens();
  return t?.refresh || null;
}

export function getDecodedAccess() {
  const access = getAccessToken();
  if (!access) return null;
  try {
    return jwtDecode(access); // π.χ. { user_id, username, email, exp, ... }
  } catch {
    return null;
  }
}